     import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import "./Works.css"
import { FaLink } from 'react-icons/fa';


export const Works = () => {
  const [data, setData]=useState(Categories)
  const filterResult=(catItem)=>{
     const result=Categories.filter((curData)=>{
      return curData.category===catItem;
     });
     setData(result)
  }
  return (
   <div className='f-c work-container'> 
   <h3 className='the-head'><span>P</span>rojects Completed</h3>   
    <nav className='nav'>
    
    <ul>
      <li style={{color:"royablue", fontWeight:"600"}}onClick={()=>setData(Categories)}>All</li>
      <li onClick={()=>filterResult('web')}> Web development</li>
      <li onClick={()=>filterResult('print')}>Printing Production</li>
    </ul>
</nav>
<br />

<div className="work-done-box">
{data.map((values)=>{
          const {id, name, image, weblink, profession}=values;
        
          return(
              <>
              <Link to={weblink}>
                  <div className="work-done" key={id}>
                    <img src={image} alt="" />
                    <div className='work-done-details'>
                    <h3>{name}</h3>
                    <p>{profession}</p>
                    <Link to={weblink} className='view-web'>
                       View <FaLink />
                    </Link>
                    </div>
                  </div>
                  </Link>
          
              </>
          )
      })}


</div>
</div>
  )
}

export const Categories = [
    {
    id: 1134211,
    name: "jubriloflaogos.com",
    image: 'image/jubril.png',
    profession: "Personal Website",
    category: "web",
    weblink: "https://www.jubriloflagos.com/"
  },
  {
    id: 1342111,
    name: "kleenfold.com",
    image: 'image/kleenfold.png',
    profession: " Laundry Website",
    category: "web",
    weblink: "https://www.kleenfold.com/"
  },
  {
    id: 116711,
    name: "augustergold.co.uk",
    image: 'image/augustergold.png',
    profession: "Women Website",
    category: "web",
    weblink: "https://www.augustergold.co.uk/"
  },
  {
    id: 11111,
    name: "unitinnovative.com",
    image: 'image/unitinnovative.png',
    profession: "Market Place Website",
    category: "web",
    weblink: "https://www.unitinnovative.com/"
  },
   {
    id: 11511,
     name: "sisiosa.com",
     image: 'image/sisiosa.png',
     profession: " E-commerce Website",
    category: "web",
    weblink: "https://www.sisiosa.com/"
  },
  {
    id: 111551,
    name: "rccgtmp.com",
    image: 'image/rccgtmp.png',
    profession: " Church Website",
    category: "web",
    weblink: "https://www.rccgtmp.com/"
  },

  {
    id: 16766456,
    name: "rosadav.com.ng",
    image: 'image/rosadav.png',
    profession: "Power & Energy Website",
    category: "web",
    weblink:"https://www.rosadav.com.ng/"
  },
   {
    id: 154657,
    name: "goldenmoes.com",
    image: 'image/auguster.png',
    profession: "Augerster and Moses Wedding",
    category: "web",
    weblink:"https://www.goldenmoes.com/"
  },

  {
    id: 2,
    name: "diamondtravelservices.org",
    image: 'image/diamond.png',
    profession: " Immigration Website",
    category: "web",
    weblink:"https://www.diamondtravelservices.org/"
  },
  {
    id: 9,
    name: "print.multibranddigital.com",
    image: 'image/naijaprint.png',
    profession: " Printing Website",
    category: "web",
    weblink: "https://print.multibranddigital.com/"
  },
  {
    id: 6,
    name: "tapecommunications.com",
    image: 'image/tape.png',
    profession: "Media Website",
    category: "web",
    weblink: "https://www.tapecommunications.com/"
  },
  {
    id: 11511,
    name: "dbgcfoundation.com",
    image: 'image/foundation.png',
    profession: " Church Website",
    category: "web",
    weblink: "https://www.dbgcfoundation.com/"
  },
  {
    id: 14,
    name: "soromaniatech.com",
    image: 'image/sammy.png',
    profession: "Data Science Website",
    category: "web",
    weblink: "https://sammytech.vercel.app/"
  },
  {
    id: 165432,
    name: "ourlove.online",
    image: 'image/wed.png',
    profession: "Wedding Planning Website",
    category: "web",
    weblink: "https://www.ourlove.online/"
  },
  {
    id: 1,
    name: "webglobal.com",
    image: 'image/web.png',
    profession: "Website Builder Platform",
    category: "web",
     weblink: "https://web.multibranddigital.com/"
  },


  // {
  //   id: 3,
  //   name: "zeavix.com",
  //   image: 'image/zeavix.png',
  //   profession: " Shortlets and Events Website",
  //   category: "web",
  //   weblink:"https://www.zeavix.com/"
  // },
  // {
  //   id: 3654,
  //   name: "swiftshipping.com",
  //   image: 'image/swift.png',
  //   profession: " Shipping and Logistics",
  //   category: "web",
  //   weblink: "https://swiftshipping.vercel.app/"
  // },
  // {
  //   id: 34654,
  //   name: "stirringthewater.com",
  //   image: 'image/stirring.png',
  //   profession: " Church Website",
  //   category: "web",
  //   weblink: "https://ceenai.vercel.app/"
  // },
  // {
  //   id: 13,
  //   name: "alertronic.ng",
  //   image: 'image/alertronic.png',
  //   profession: "E-commerce Tech Website",
  //   category: "web",
  //   weblink: "https://alertronic.vercel.app/"
  // },
  //   {
  //   id: 39876,
  //   name: "prestontouch.com",
  //   image: 'image/preston.png',
  //   profession: " Luxury Website",
  //   category: "web",
  //   weblink:"https://prestontouch.vercel.app/"
  // },

  // {
  //   id: 4,
  //   name: "adcoreconsulting.com",
  //   image: 'image/adcore.png',
  //   profession: " Printing Website",
  //   category: "web",
  //   weblink:"https://adcoreconsulting.vercel.app/"
  // },

  // {
  //   id: 5,
  //   name: "wellnessmartialart.com",
  //   image: 'image/web20.png',
  //   profession: "Yoga & Martial Art development",
  //   category: "web",
  //   weblink:"https://wellnessmartialart.vercel.app/"
  // },
 

  // {
  //   id: 7,
  //   name: "bsolusholaenergy.ng",
  //   image: 'image/web25.png',
  //   profession: "Eletrical Website",
  //   category: "web",
  //   weblink:"https://bsolusholaenergy.ng"
  // },

  // {
  //   id: 8,
  //   name: "printhub.com.ng",
  //   image: 'image/printhub.png',
  //   profession: " Business Website",
  //   category: "web",
  //   weblink:"https://printhub-omega.vercel.app/"
  // },
 
 
  // {
  //   id: 10,
  //   name: "linkyoutube.com",
  //   image: 'image/link-youtube.png',
  //   profession: " Youtube Video Saver Website",
  //   category: "web",
  //   weblink:"https://linkyoutube.vercel.app/"
  // },

  // {
  //   id: 1121,
  //   name: "multibrandprints.com.ng",
  //   image: 'image/web10.png',
  //   profession: "Printing Website",
  //   category: "web",
  //   weblink:"https://multibrandprints.com.ng/"
  // },
//  {
//     id: 99876,
//     name: "https://church.com.",
//     image: 'image/church.png',
//     profession: " Church Website",
//     category: "web",
//     weblink:"https://churchit.vercel.app//"
//   },
// {
//   id: 547,
//   name: "Company Branding",
//   image: 'image/metaphor.png',
//   profession: "Signage Branding",
//   category: "print",
//   weblink:"https://www.instagram.com/p/Cw9kaeiMzha/"
// },
// {
//   id: 112,
//   name: "Diary Publication",
//   image: '/image/image1.png',
//   profession: "Printing Production",
//   category: "print",
//   weblink:"https://www.instagram.com/p/Clbw6WfsYJ9/"
// },
// {
//   id: 15,
//   name: "Professional Website",
//   image: 'image/web3-image.png',
//   profession: "Web development",
//   category: "web",
//   weblink:"https://my-css-layout-project.vercel.app/"
// },

// {
//   id: 16,
//   name: "E-commerce Sell App",
//   image: 'image/web7-image.png',
//   profession: "E-commerce App",
//   category: "web",
//   weblink:"https://product-kappa-beryl.vercel.app/"
// },
//   {
//     id: 17,
//     name: "Music Web Application",
//     image: 'image/web5-image.png',
//     profession: "Web Applications",
//     category: "web",
//     weblink:"https://music-eight-rose.vercel.app/"
//   },

// {
//   id: 8,
//   name: "Company Branding / Decoration",
//   image: 'image/signage.png',
//   profession: "Company Branding",
//   category: "print",
//   weblink:"https://www.instagram.com/p/CwnJNQesPXT/"
// },
// {
//   id: 9,
//   name: "Book Printing / Publication",
//   image: 'image/book2.png',
//   profession: "Book Publication",
//   category: "print",
//   weblink:"https://www.instagram.com/p/CwcWf6bAeEw/"
// },
// {
//   id: 10,
//   name: "Product Branding Box",
//   image: 'image/pizza.png',
//   profession: "Box Printing / Branding",
//   category: "print",
//   weblink:"https://www.instagram.com/p/C06cDWxM0IY/"
// },
// {
//   id: 11,
//   name: "Carrier Bag Production",
//   image: 'image/bag-image.png',
//   profession: "Bag Printing ",
//   category: "print",
//   weblink:"https://www.instagram.com/p/C7Yjbb2MDr0/"
// },


// {
//   id: 11,
//   name: "Music Web Application",
//   image: 'image/web5-image.png',
//   profession: "Web Aoolications",
//   category: "web",
//   weblink:"https://music-eight-rose.vercel.app/"
// },
]